import React from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    fontSize: '13px',
    fontWeight: 'bold',
    padding: '3px 20px'
  }
}));

const OutlinedButton = ({ children, classes, ...props }) => {
  const { root } = useStyles();

  return (
    <Button
      variant="outlined"
      color="primary"
      classes={{ root, ...classes }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default OutlinedButton;
